<template>
    <div class="relative flex h-14">
        <div class="flex w-full justify-between">
            <img
                v-if="app.tenant?.logo"
                :src="app.tenant.logo"
                class="h-14 max-w-48"
            />
            <SvgIcon
                v-else
                class="w-32"
                name="movepro_logo"
            />
            <div class="my-auto ml-auto flex justify-between gap-3">
                <a
                    v-if="app.tenant?.phone"
                    :href="`tel:${app.tenant.phone}`"
                    class="my-auto block rounded-full px-1 py-1.5 text-sm text-muval-gray-1 lg:hidden"
                    @click="analytics.phoneClicked()"
                >
                    <SvgIcon
                        class="h-5 w-5"
                        name="system-phone"
                    />
                </a>
                <ViewBook class="lg:hidden" />
            </div>
        </div>
    </div>
</template>

<script setup>
import ViewBook from './utilities/ViewBook.vue';
import { useAppStore, useAnalyticsStore } from '@/store';

const app = useAppStore();
const analytics = useAnalyticsStore();
</script>
